import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Col, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

class Dialog extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      show: true,
      value: ''
    }
  }

  componentDidMount() {
    if (this.input) this.input.focus()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: true, value: '' })
  }

  getValue = () => this.state.value
  onChange = e => this.setState({ value: e.target.value })

  onConfirm = () => {
    if (this.props.onConfirm) this.props.onConfirm(this.state.value)
    this.setState({ show: false })
  }

  onCancel = () => {
    if (this.props.onCancel) this.props.onCancel()
    this.setState({ show: false })
  }

  form = () => {
    const { input } = this.props
    if (!input) return null

    return (
      <Form horizontal>
        <FormGroup controlId='dialoginput'>
          <Col componentClass={ControlLabel} sm={2}>
            {input}:
          </Col>
          <Col sm={8}>
            <FormControl inputRef={r => this.input = r} value={this.state.value || ''} onChange={this.onChange}/>
          </Col>
        </FormGroup>
      </Form>
    )
  }


  render() {
    if (!this.state.show) return null
    const { title, content, confirm, cancel } = this.props

    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { content }
          { this.form() }
        </Modal.Body>
        <Modal.Footer>
          { cancel ? <Button bsStyle='warning' className='btn-sm btn-outline' onClick={this.onCancel}>{cancel}</Button> : null }
          <Button bsStyle='primary' className='btn-sm btn-outline' onClick={this.onConfirm}>{confirm}</Button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}

Dialog.defaultProps = {
  confirm: 'Confirm',
  cancel: 'Cancel'
}
Dialog.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  input: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}
export default Dialog



// WEBPACK FOOTER //
// ./src/components/widgets/Dialog.js